import { Route } from 'vue-router';
import store from '@/store/store';
import { EnumPlans } from '@/enums/Plans';
import { EnumUserRoles } from '@/enums/UserRole';

export const hasPlanAccess = (minAccess: EnumPlans): boolean => {
  const { session = {} } = store.state['session'];

  return session.plan && EnumPlansOrder[minAccess.valueOf()] <= EnumPlansOrder[session.plan];
};

export const hasUserAccess = (roles: EnumUserRoles[]): boolean => {
  const { session = {} } = store.state['session'];

  return session.plan && roles.includes(session.user_role);
};

export const hasAccessToTeam = (
  teamId: string,
  securityRestrict: boolean,
  userRole: EnumUserRoles,
  userTeamId: string
): boolean => {
  if (!securityRestrict) {
    return true;
  }

  switch (userRole) {
    case EnumUserRoles.user:
      return teamId === userTeamId;
    case EnumUserRoles.manager:
      if (!userTeamId) {
        return true; // if manager does not belong to a team he/she should see any team
      }
      return teamId === userTeamId; //if manager does belong to a team, only show his/her team
    case EnumUserRoles.admin:
      return true;
  }
  return false;
};

export const showUpgradeModal = (plan: EnumPlans) => {
  store.dispatch('toggleUpgradeModal', plan);
};

enum EnumPlansOrder {
  solo = 1,
  starter = 2,
  business = 3,
  free = 4,
  pro = 5,
  essential = 6,
  professional = 7,
  enterprise = 8,
  enterpriseplus = 9,
  partner = 10,
  trial = 11,
}

export const hasRouteAccess = (to: Route) => {
  const { meta } = to;
  if (!meta) {
    return true;
  }
  const accesses = [];
  if (meta.planAccess) {
    accesses.push(hasPlanAccess(meta.planAccess));
  }
  if (meta.userAccess) {
    accesses.push(hasUserAccess(meta.userAccess));
  }
  return !accesses.includes(false);
};
